import React from 'react';
import { Pagination, HeroIconCheveronLeft } from 'toolbox';
import classNames from 'classnames';
import {
  PaginationProps,
  usePaginationContext,
} from 'toolbox/src/components/Pagination/Pagination';
import Flex from 'toolbox/src/components/Flex/Flex';
import HeroIconCheveronRight from 'toolbox/src/components/HeroIcons/HeroIconCheveronRight';

export const JcapPagination: React.FC<PaginationProps> = (props) => {
  return (
    <Pagination.Wrapper {...props}>
      <Flex
        className="w-full"
        justifyContent="space-between"
        alignItems="center"
      >
        <PrevButton>
          <HeroIconCheveronLeft />
        </PrevButton>
        <PageIndicator />
        <NextButton>
          <HeroIconCheveronRight />
        </NextButton>
      </Flex>
    </Pagination.Wrapper>
  );
};

export default JcapPagination;

const NextButton: React.FC = ({ children }) => {
  const { canGoToTheNextPage, goToNextPage } = usePaginationContext();
  const disabled = !canGoToTheNextPage;
  return (
    <button
      data-testid="pagination-next-button"
      className={classNames(
        'px-2 py-1 rounded',
        'focus:outline-none',
        'focus:bg-gray-300',
        disabled ? 'bg-gray-100 text-gray-400' : 'bg-gray-200 text-gray-600',
      )}
      disabled={disabled}
      onClick={goToNextPage}
    >
      {children}
    </button>
  );
};

const PrevButton: React.FC = ({ children }) => {
  const { canGoToThePreviousPage, goToPrevPage } = usePaginationContext();
  const disabled = !canGoToThePreviousPage;
  return (
    <button
      data-testid="pagination-prev-button"
      className={classNames(
        'px-2 py-1 rounded',
        'focus:outline-none',
        'focus:bg-gray-300',
        disabled ? 'bg-gray-100 text-gray-400' : 'bg-gray-200 text-gray-600',
      )}
      disabled={disabled}
      onClick={goToPrevPage}
    >
      {children}
    </button>
  );
};

const PageIndicator: React.FC = ({ children }) => {
  const { totalPageDisplayValue, pageDisplayValue } = usePaginationContext();
  return (
    <p className="text-xs text-gray-600">
      Page {pageDisplayValue}/{totalPageDisplayValue}
    </p>
  );
};
